/**
 * The buttons a phone needs that a keyboard would otherwise cover.
 *
 * There is no stick: tapping where you want to go is a better fit for a game
 * whose position is a tile, and a thumb pad over the world only took room away
 * from the thing being tapped.
 */

export function TouchButtons({
  running,
  chatOpen,
  onToggleRun,
  onOpenChat,
}: {
  running: boolean;
  chatOpen: boolean;
  onToggleRun: () => void;
  onOpenChat: () => void;
}): JSX.Element {
  return (
    <div className="touch-buttons">
      <button
        type="button"
        className={running ? 'touch-button on' : 'touch-button'}
        onClick={onToggleRun}
      >
        {running ? 'Run' : 'Walk'}
      </button>
      <button
        type="button"
        className={chatOpen ? 'touch-button on' : 'touch-button'}
        onClick={onOpenChat}
      >
        Chat
      </button>
    </div>
  );
}
